import React from 'react';
import { db } from '../firebase';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        const { accountID, current360ID } = this.props;

        this.setState({ errorInfo });

        let message = "";
        if (this.props.errorLocation === 'helmet') {
            message = "Error: Render lifecycle failure - React Helmet";
        } else {
            message = "Error: Render lifecycle failure - Component";
        }

        db.doLogLoadingErrorFromWithBranding(accountID, current360ID, message, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='vh-100 vw-100 flex items-center justify-center flex-wrap'>
                    <div>
                        <p>{this.state.errorInfo}</p>
                        <p>Please try again or contact an administrator.</p>
                    </div>
                </div>
            )
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
